import { SyntheticEvent } from "react";
import { Button } from "@/shared/ui";

type Props = {
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
  onBack: () => void;
};

export default function PlayerMenuSettingsSafetyContactWithAdministration({
  onSubmit,
  onBack,
}: Props) {
  return (
    <div className="gap-3 grow flex flex-col">
      <div className="text-16 text-white font-medium">Сброс 2FA</div>
      <div className="text-15 text-white/60 font-medium">
        Cвяжитесь с администрацией перейдя по ссылке ниже и заполнив соответствующую форму на нашем
        сайте.
      </div>
      <div className="grid grid-cols-2 gap-2 mt-auto ">
        <Button variant="solid-surface-gradient" className="w-full" onClick={onBack}>
          Назад
        </Button>
        <Button submit className="w-full">
          СВЯЗАТЬСЯ С АДМИНИСТРАЦИЕЙ
        </Button>
      </div>
    </div>
  );
}
